import umbraco from '~/lib/api/umbraco';
import { UmbracoTypes } from '~/lib/data-contract';
import { getUrl } from '~/services/umbraco/utils';

export default function getFrameNavigation(signal: AbortSignal | undefined, levels: number) {
    const url = getUrl('/content/frame/frame-navigation');
    url.searchParams.append('levels', String(levels));
    url.searchParams.append('url', '/');

    return umbraco.get(url, { signal }).json<UmbracoTypes.INavigation>();
}
